import { Button, ButtonProps, styled } from "@mui/material";
import React from "react";

export const StyledFetchMore = styled(Button)`
  padding: ${(props) => props.theme.spacing(2)};
  background: ${(props) => props.theme.palette.secondary.main};
  color: ${(props) => props.theme.palette.secondary.contrastText};
  width: 100%;
  border-radius: 0;

  &:hover {
    background: ${(props) => props.theme.palette.secondary.dark};
  }
`;

interface Props extends ButtonProps {
  isLoading?: boolean;
}

export const ListFetchMore = ({ isLoading, ...boxProps }: Props) => {
  return (
    <StyledFetchMore {...boxProps} disabled={isLoading || boxProps.disabled}>
      {isLoading ? "Chargement..." : "Afficher plus"}
    </StyledFetchMore>
  );
};
